var React = require('react');

function SelectInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L5 5L9 1","stroke":"#E6E5E1","strokeWidth":"2"}));
}

SelectInline.defaultProps = {"viewBox":"0 0 10 7","fill":"none"};

module.exports = SelectInline;

SelectInline.default = SelectInline;
